module.exports = __webpack_public_path__ + "static/media/brand-library-royal.1df3d9a5.svg";